// src/data/exercises/L4_06.js

const accountOptions = [
  '支払手数料', '有価証券', '現金', '受取手数料', '当座預金'];

export const L4_06 = {
  title: '簿記　3級（第212-6回）',
  questions: [
    {
      id: 'q1',
      type: 'JOURNAL_ENTRY',
      content: {
   parts: [
    { "type": "ruby", "text": "高知商事株式会社", "ruby": "こうちしょうじかぶしきがいしゃ" },
    { "type": "text", "value": "の" },
    { "type": "ruby", "text": "株式", "ruby": "かぶしき" },
    { "type": "text", "value": "300" },
    { "type": "ruby", "text": "株", "ruby": "かぶ" },
    { "type": "text", "value": "を１株につき￥770で" },
    { "type": "ruby", "text": "購入", "ruby": "こうにゅう" },
    { "type": "text", "value": "し、その" },
    { "type": "ruby", "text": "代金", "ruby": "だいきん" },
    { "type": "text", "value": "は" },
    { "type": "ruby", "text": "証券会社", "ruby": "しょうけんがいしゃ" },
    { "type": "text", "value": "に" },
    { "type": "ruby", "text": "対", "ruby": "たい" },
    { "type": "text", "value": "する" },
    { "type": "ruby", "text": "購入手数料", "ruby": "こうにゅうてすうりょう" },
    { "type": "text", "value": "￥5,000とともに" },
    { "type": "ruby", "text": "現金", "ruby": "げんきん" },
    { "type": "text", "value": "で" },
    { "type": "ruby", "text": "支払", "ruby": "しはら" },
    { "type": "text", "value": "った。" }
],
      },
      table: {
        options: accountOptions,
      },
      answer: [
        { debitAccount: '有価証券', debitAmount: 236000, creditAccount: '現金', creditAmount: 236000},
      ],

      // Giải thích chi tiết khi trả lời ĐÚNG (có định dạng)
      explanation_correct: {
        parts: [
          { type: 'text', value: '①まず、一番大切なことばは、株式\n' },
          { type: 'text', value: '次に、購入（買う）なのか売却（売る）\n' },
          { type: 'text', value: 'この問題では、購入なので\n' },
          { type: 'text', value: '有価証券が増加（プラス）します。\n' },
          { type: 'text', value: '次に、金額は￥770×300＋5,000（購入手数料）＝？\n' },
          { type: 'styled', value: '有価証券の増加（プラス）は借方（左・Ｄｒ）に記入します。\n\n', color: 'red', bold: true },
          { type: 'text', value: '②次に、現金で払ったので\n' },
          { type: 'text', value: '現金が減少（マイナス）します。\n' },
          { type: 'styled', value: '現金の減少（マイナス）は貸方（右・Ｃｒ）に記入します。', color: 'red', bold: true },
        ]
      },

      // Gợi ý 2 cấp độ khi trả lời SAI
      hints: {
        account: [
          // Gợi ý lần 1, 2
`①まず、一番大切なことばは、株式
次に、購入（買う）なのか売却（売る）
この問題では、購入なので
有価証券が増加（プラス）します。
次に、金額は￥770×300＋5,000（購入手数料）＝？

②次に、現金で払ったので
　現金が減少（マイナス）します。



`,
          // Gợi ý lần 3 (chi tiết hơn, có định dạng)
          {
          parts: [
          { type: 'text', value: '①まず、一番大切なことばは、株式\n' },
          { type: 'text', value: '次に、購入（買う）なのか売却（売る）\n' },
          { type: 'text', value: 'この問題では、購入なので\n' },
          { type: 'text', value: '有価証券が増加（プラス）します。\n' },
          { type: 'text', value: '次に、金額は￥770×300＋5,000（購入手数料）＝？\n' },
          { type: 'styled', value: '有価証券の増加（プラス）は借方（左・Ｄｒ）に記入します。\n\n', color: 'red', bold: true },
          { type: 'text', value: '②次に、現金で払ったので\n' },
          { type: 'text', value: '現金が減少（マイナス）します。\n' },
          { type: 'styled', value: '現金の減少（マイナス）は貸方（右・Ｃｒ）に記入します。', color: 'red', bold: true },
        ]
          }
        ],
       
        
      },
    },
  ],
};